import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { CapabilitiesService, routeResources } from '../services/capabilities.service';

export const capabilityGuard: CanActivateChildFn = async (_route, state) => {
  const capabilities = inject(CapabilitiesService);
  const router = inject(Router);
  await capabilities.load();
  const parts = state.url.split('?')[0].split('/').filter(Boolean);
  if(parts[0]==='integrations')return capabilities.can('company','read')||capabilities.can('api_key','read')?true:router.createUrlTree(['/home']);
  const resource = routeResources[parts[0]];
  const action = parts.includes('new') || parts.includes('upload') || parts.includes('invite') ? 'create'
    : parts.includes('edit') || parts.includes('branding') ? 'update' : 'read';
  if (parts[0] === 'companies' && action !== 'read' && !capabilities.can('company', action)) {
    return router.createUrlTree(['/home']);
  }
  return !resource || capabilities.can(resource, action) ? true : router.createUrlTree(['/home']);
};
